import { render, staticRenderFns } from "./ConveniosListagem.vue?vue&type=template&id=7530588a&scoped=true&"
import script from "./ConveniosListagem.vue?vue&type=script&lang=js&"
export * from "./ConveniosListagem.vue?vue&type=script&lang=js&"
import style0 from "./ConveniosListagem.vue?vue&type=style&index=0&id=7530588a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7530588a",
  null
  
)

export default component.exports